import type { ApiPostGiratudoParticipatePort } from '~/handlers/ports/api-post-giratudo-participate.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

export class ApostatudoApiPostGiratudoParticipateAdapter
  implements ApiPostGiratudoParticipatePort
{
  async handle(userId: number, username?: string) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    const body: Record<string, unknown> = { user_id: userId };

    if (username) body.username = username;

    const response = await fetch(
      `${getApostatudoApiUrl()}/hourly-raffle/participate`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        signal: controller.signal,
      },
    ).finally(() => clearTimeout(timeoutId));

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      const message =
        err?.reason === 'participation_disabled'
          ? 'Sorteios temporariamente indisponíveis.'
          : (err?.message ?? 'Erro ao participar do sorteio.');

      throw new Error(message);
    }

    const data = await response.json();

    return {
      ticketNumber: data.ticket_number,
      raffleEndTime: data.raffle_end_time,
    };
  }
}
